export default [
  {
    title: 'breadcrumb.requestWithdraw',
    route: 'request-withdraw',
    icon: '',
    resource: 'request-withdrawal',
    action: 'read',
    tag: 0,
  },
]
